import styled from 'styled-components';

export const ImgStyled = styled.div<{ height?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    height: ${(props) => props.height || 'auto'};
    border-radius: 12px;
  }

  &.welcome-img {
    justify-content: start;
    @media (max-width: 1040px) {
      justify-content: center;
    }
  }
`;

export const ColorTextStyled = styled.div<{ color?: string }>`
  color: ${(props) => props.color || '#F62369'};

  h2 {
    font-size: 28px;
    line-height: 1.2;
    margin-bottom: 8px;
  }
`;

export const FlexCenterStyled = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
`;

export const MinHeightStyled = styled.div`
  height: 500px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const StyledTabs = styled.div`
  .Polaris-Tabs__Tab:not([aria-disabled='true']):hover {
    background: #fabdcc;
  }

  .Polaris-Tabs__Tab--active,
  .Polaris-Tabs__Tab--active:not([aria-disabled='true']):focus,
  .Polaris-Tabs__Tab--active:not([aria-disabled='true']):hover {
    background: #f889a8;
  }
`;

export const ButtonContainerStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media (max-width: 576px) {
    justify-content: space-between;
  }
`;

export const RadioTabStyled = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 22px;
  @media (max-width: 576px) {
    position: relative;
    left: unset;
    bottom: unset;
  }
`;
